import ArticleContent from './component';

export default ArticleContent;
